module.exports = __webpack_public_path__ + "img/yml_gallery17.63e3efb3.jpg";